import { Component, OnInit } from '@angular/core';
import { ProductService } from "../services/product/product.service";
import { CategoryService } from '../services/category/category.service';
import { environment } from "../../environments/environment";
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from '@angular/router';
@Component({
  selector: 'app-serie',
  templateUrl: './serie.component.html',
  styleUrls: ['./serie.component.css']
})
export class SerieComponent implements OnInit {
   idFournisseur;
   brand;
   products;
   pageSize = 12;
   page;
   total;
   categories
   baseUrl = environment.baseUrl
   allCode3 = []
   allCode33 = []
   allCategories = []
   series;
   startIndex = 1;
  totalPages = 0;
  itemsPerPage = 12;
  pageNumbers: any;
  constructor(private productService:ProductService,private route: ActivatedRoute,private categoryService:CategoryService,private router: Router) { }

  nextPage() {
    if (this.startIndex < this.totalPages) {
      this.startIndex++;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.getAllProducts(this.idFournisseur)
    }
  }

  previousPage() {
    if (this.startIndex > 1) {
      this.startIndex--;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.getAllProducts(this.idFournisseur)
    }
  }

  goToPage(pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.startIndex = pageNumber;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.getAllProducts(this.idFournisseur)
    }
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.idFournisseur = params.get('id')
      this.categoryService.allCategories().subscribe(res =>{
         this.brand = res['fournisseurs'][this.idFournisseur]
         this.series = res['series']
         for (let key in this.series) {
            // code block to be executed
            this.allCategories.push({id:key,name:this.series[key]})
          }
         console.log("serie",this.series);

      })
      this.getAllProducts(this.idFournisseur)
    })
  }

  onPageChange(numPage: number) {
    this.page = numPage
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }


  changeMax(nbrProducts){
    // this.pageSize = nbrProducts;
    this.itemsPerPage = nbrProducts;
    this.getAllProducts(this.idFournisseur);
  }
  getAllProducts(idFournisseur){
    this.productService.searchBySerie(idFournisseur, this.startIndex, this.itemsPerPage).subscribe(res => {
      this.products     = res['products'];
      this.categories   = res['categories'];
      
      this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage); 
      if (this.totalPages > 10) {
        if (
          Number(this.startIndex) <= this.totalPages - 5 &&  Number(this.startIndex) > this.totalPages - 5 || 
          Number(this.startIndex) <= this.totalPages - 4 &&  Number(this.startIndex) > this.totalPages - 5 ||
          Number(this.startIndex) <= this.totalPages - 3 &&  Number(this.startIndex) > this.totalPages - 5 ||
          Number(this.startIndex) <= this.totalPages - 2 &&  Number(this.startIndex) > this.totalPages - 5 ||
          Number(this.startIndex) <= this.totalPages - 1 &&  Number(this.startIndex) > this.totalPages - 5 ||
          Number(this.startIndex) <= this.totalPages &&  Number(this.startIndex) > this.totalPages - 5
          ) {
          this.pageNumbers = [
            1, 2 , '...', this.totalPages - 4,  this.totalPages - 3,  this.totalPages - 2,  this.totalPages - 1,  this.totalPages
          ];
        } else {
          if (Number(this.startIndex) > 2) {
            this.pageNumbers = [
              1, 2 , '...', this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
            ];
          } else {
            this.pageNumbers = [
              this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
            ];
          }
        }
      } else {
        this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1);
      }
      res['categories'].forEach(element => {
        this.allCode33.push(element.TSICOD3)
      });
    })
  }

  filtreBySerie(idSerie){
    window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
     });

    if(idSerie !=''){
      this.productService.productsBySerie(idSerie,this.idFournisseur).subscribe(res => {
        this.products = res['products'];
        this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage); 
      if (this.totalPages > 10) {
        if (
          Number(this.startIndex) <= this.totalPages - 5 &&  Number(this.startIndex) > this.totalPages - 5 || 
          Number(this.startIndex) <= this.totalPages - 4 &&  Number(this.startIndex) > this.totalPages - 5 ||
          Number(this.startIndex) <= this.totalPages - 3 &&  Number(this.startIndex) > this.totalPages - 5 ||
          Number(this.startIndex) <= this.totalPages - 2 &&  Number(this.startIndex) > this.totalPages - 5 ||
          Number(this.startIndex) <= this.totalPages - 1 &&  Number(this.startIndex) > this.totalPages - 5 ||
          Number(this.startIndex) <= this.totalPages &&  Number(this.startIndex) > this.totalPages - 5
          ) {
          this.pageNumbers = [
            1, 2 , '...', this.totalPages - 4,  this.totalPages - 3,  this.totalPages - 2,  this.totalPages - 1,  this.totalPages
          ];
        } else {
          if (Number(this.startIndex) > 2) {
            this.pageNumbers = [
              1, 2 , '...', this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
            ];
          } else {
            this.pageNumbers = [
              this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
            ];
          }
        }
      } else {
        this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1);
      }
      })
    }

  }

}
